import { render, staticRenderFns } from "./Viplist.vue?vue&type=template&id=d63a55ce&scoped=true&"
import script from "./Viplist.vue?vue&type=script&lang=js&"
export * from "./Viplist.vue?vue&type=script&lang=js&"
import style0 from "./Viplist.vue?vue&type=style&index=0&id=d63a55ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63a55ce",
  null
  
)

export default component.exports